import Button from 'components/Button'
import { FilterText } from 'components/FilterDiv'
import SearchInput from 'components/SearchInput'
import { StyledTable } from 'components/TableStyles/TableStyles'
import RoleDetails from 'modules/Dashboard/Partials/DashboardRoles/Partials/RolesInfoTable/Partials/RoleDetails'
import RoleFilter from 'modules/Dashboard/Partials/DashboardRoles/Partials/RolesInfoTable/Partials/RoleFilter'
import {
  NavWrapper,
  StyledP,
  TableTop,
} from 'modules/Dashboard/Partials/DashboardRoles/Partials/RolesInfoTable/Style/style'
import moment from 'moment'
import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { formatNumber } from 'utils/formatNumber'

const RolesInfoTable = ({
  dashboardRoleList,
  rolesList,
  updateRoleData,
  setJobId,
  setUrl,
  currentUrl,
  setCurrentPage,
  currentPage,
  getJobDetails,
  corporateAboutUs,
  onAcceptOrRejectClick,
  onSortValueChanged,
  loading = false,
  setSearch,
  citiesList,
  getCities,
  setFilterQuery,
  sortBy,
  setSortBy,
  orderBy,
  setOrderBy,
}) => {
  const instituteData = useSelector(state => state.auth.instituteDetails)

  const navigate = useNavigate()

  const delaySaveToDb = useCallback(
    debounce(text => {
      setCurrentPage(0)
      setSearch(text)
    }, 1000),
    []
  )
  function debounce(fn, delay) {
    let timer
    return function () {
      let context = this,
        args = arguments
      clearTimeout(timer)
      timer = setTimeout(() => {
        fn.apply(context, args)
      }, delay)
    }
  }

  const checkDate = date => {
    return moment(date).format('DD/MM/YYYY')
  }

  const getMaxCTC = role => {
    if (role?.CTCIsTierBased) {
      let tier = instituteData?.tier
      let obj = role?.CTC.find(val => {
        return val.name == `tier${tier}`
      })
      if (obj) {
        if (obj?.isRange) {
          return `₹${formatNumber(+obj?.min)} - ₹${formatNumber(+obj?.max)}`
        }
        return `₹${formatNumber(+obj?.max)}`
      }
      return `₹${formatNumber(+role?.maxCompensation)}`
    }
    return `₹${formatNumber(+role?.maxCompensation)}`
  }
  const columns = [
    {
      title: 'Roles',
      dataIndex: '',
      sorter: true,
      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('tittle')
          },
        }
      },

      width: '25%',
      sortDirections: ['ascend', 'descend'],
      render: (text, data) => <RoleDetails data={data} />,
    },
    {
      title: 'Compensation',
      sorter: true,
      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('maxCompensation')
          },
        }
      },
      key: 'maxCompensation',
      sortDirections: ['ascend', 'descend'],
      render: (text, item) => (
        <StyledP>
          {getMaxCTC(item?.jobRoles)} Per
          {item?.jobRoles?.CTCPeriod == 'ANNUALLY' ? ' annum' : ' month'}
        </StyledP>
      ),
    },
    {
      title: 'App. last date',
      sorter: true,
      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('postedDate')
          },
        }
      },
      sortDirections: ['ascend', 'descend'],
      render: (text, data) => (
        <StyledP>{checkDate(data?.jobRoles?.endDate)}</StyledP>
      ),
    },
    {
      title: 'Tot . students',
      sorter: false,
      sortDirections: ['descend'],
      render: (text, data) => <StyledP>{data?.totalStudents}</StyledP>,
    },
    {
      title: 'Eligible . Stu',
      sorter: false,
      sortDirections: ['descend'],
      render: (text, data) => <StyledP>{data?.eligibleStudents}</StyledP>,
    },
    {
      title: 'tot . stu . applied',
      sorter: false,
      sortDirections: ['descend'],
      render: (text, data) => <StyledP>{data?.appliedStudents}</StyledP>,
    },
    {
      title: 'Action',
      dataIndex: 'id',
      render: (text, item) => (
        <Button.Secondary
          text="View"
          onClick={() => {
            actionClicked(item)
          }}
        />
      ),
    },
  ]
  const actionClicked = data => {
    navigate(
      `/dashboard/drives/${data?.jobRoles?.id}/${data?.jobRoles?.corporate?.id}`
    )
  }

  const paginationChange = (page, pageSize) => {
    setUrl(`${currentUrl}`)
    setCurrentPage(page - 1)
  }
  const sortFilter = sort => {
    let sortOrder = ''
    if (sort == sortBy) {
      sortOrder = orderBy == 'asc' ? 'desc' : 'asc'
    } else {
      sortOrder = 'asc'
    }
    setOrderBy(sortOrder)
    setSortBy(sort)
    onSortValueChanged(`sort=${sort}&orderBy=${sortOrder}`)
  }
  const changeFilters = filter => {
    setUrl(`${filter}`)
    setCurrentPage(0)
  }
  return (
    <NavWrapper column>
      <TableTop centerVertically>
        <SearchInput
          width={'25%'}
          placeholder="Search by role name"
          bordered={false}
          setSearchValue={text => {
            delaySaveToDb(text)
          }}
        />
        <RoleFilter
          setQuery={changeFilters}
          citiesList={citiesList}
          getCities={getCities}
          setFilterQuery={setFilterQuery}
        />
        <FilterText>
          Showing {10 * currentPage + dashboardRoleList?.result?.length} of{' '}
          {dashboardRoleList?.count}
        </FilterText>
      </TableTop>
      <StyledTable
        columns={columns}
        loading={loading}
        dataSource={dashboardRoleList?.result}
        pagination={{
          showSizeChanger: false,
          defaultPageSize: 10,
          current: currentPage + 1,
          onChange: (page, pageSize) => {
            paginationChange(page, pageSize)
          },
          total: dashboardRoleList?.count,
        }}
      />
    </NavWrapper>
  )
}

export default RolesInfoTable
